import React, { useEffect, useRef } from "react";
import EmojiPicker from "emoji-picker-react";

export default function EmojiPickerPopover({
  open,
  onClose,
  onPick,
  className = "",
  height = 360,
}) {
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    function handlePointerDown(event) {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        onClose && onClose();
      }
    }

    function handleKeyDown(event) {
      if (event.key === "Escape") {
        event.preventDefault();
        onClose && onClose();
      }
    }

    document.addEventListener("mousedown", handlePointerDown);
    document.addEventListener("touchstart", handlePointerDown);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      document.removeEventListener("touchstart", handlePointerDown);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div ref={rootRef} className={["chat-emoji-popover", className].filter(Boolean).join(" ")}>
      <EmojiPicker
        open
        theme="dark"
        emojiStyle="native"
        lazyLoadEmojis
        autoFocusSearch={false}
        searchPlaceholder="Search emoji"
        previewConfig={{ showPreview: false }}
        width="100%"
        height={height}
        onEmojiClick={(emojiData) => {
          onPick && onPick(emojiData.emoji);
          onClose && onClose();
        }}
      />
    </div>
  );
}